import { formatDate } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { LabelI18nService } from '../_services/label-i18n.service';

@Pipe({
  name: 'localizedDate',
  pure: false
})
export class LocalizedDatePipe implements PipeTransform {
  constructor(private labelI18n: LabelI18nService) {}

  transform(value: string | number | Date | null | undefined, format: string = 'shortDate'): string | null {
    if (value === null || value === undefined || value === '') return null;
    return formatDate(value, format, this.labelI18n.locale);
  }
}
